import Auth from 'src/features/auth';

export const PublicRoutes = [{ path: '*', element: <Auth /> }];
